import { fromJS } from 'immutable'
import {
  COLLAPSE_SIDEBAR_REQUEST,
  COLLAPSE_SIDEBAR_RESET,
} from './../../constants'

const init = fromJS({
  collapse: [false, false, false, false, false, false],
})

export default (state = init, action) => {
  switch (action.type) {
    case COLLAPSE_SIDEBAR_REQUEST:
      return state
        .set('collapse', action.payload)
    case COLLAPSE_SIDEBAR_RESET:
      return state
        .delete('collapse')
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sidebar/sidebar-collapse-reducer.js